import { SVGIcon } from '@superops/super-icons';
import { Button, ButtonGroup, Popover } from '@superops/ui-design-system';
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

const ActionListItem = styled.div`
  margin: 4px;
  cursor: pointer;
  padding: 8px 10px;
  border-radius: 5px;
  &:hover {
    background: #e3edff;
  }
  &.active {
    background: #0b0114 !important;
    color: #ffffff !important;
  }
`;

const ActionList = styled.div`
  height: auto;
`;

const SortComponent = (props) => {
  const [active, setActive] = useState(false);
  const {
    title,
    defaultValue,
    sortActionsList,
    handleSortAction,
    currentSortOrder,
    currentSortAttribute,
    isClassicView = false
  } = props;

  const getSortOrderIcon = () => {
    return currentSortOrder === 'ASC' ? 'SortAsc' : 'SortDesc';
  };

  const getSortOrder = () => {
    if (currentSortOrder === 'ASC') {
      return 'DESC';
    }
    return 'ASC';
  };

  const changeSortOrder = () => {
    handleSortAction({
      attribute: currentSortAttribute || defaultValue?.value,
      order: getSortOrder()
    });
  };

  const changeSortAttr = (attr) => {
    setActive(!active);
    handleSortAction({ attribute: attr, order: currentSortOrder || 'DESC' });
  };

  return (
    <Popover
      active={active}
      activator={
        <ButtonGroup segmented>
          <Button
            {...(isClassicView && { tertiary: true })}
            onClick={changeSortOrder}
            icon={<SVGIcon name={getSortOrderIcon()} size="md" />}
          />
          <Button
            {...(isClassicView && { tertiary: true })}
            onClick={() => setActive(!active)}
            disclosure
          >
            <div
              className={`${
                isClassicView
                  ? `${props.minWidth ? 'w-40' : 'w-60'} ellipsis`
                  : ''
              }`}
            >
              <FormattedMessage id={title || defaultValue?.label} />
            </div>
          </Button>
        </ButtonGroup>
      }
      onClose={() => setActive(!active)}
      preferredAlignment="left"
      fullWidth
      fullHeight
    >
      <ActionList>
        {sortActionsList.map((action) => {
          const { label, value } = action;
          let isActive = false;
          if (currentSortAttribute) {
            isActive = value === currentSortAttribute;
          } else {
            isActive = value === defaultValue?.value;
          }
          return (
            <ActionListItem
              onClick={() => changeSortAttr(value)}
              className={isActive ? 'active' : ''}
            >
              <FormattedMessage id={label} />
            </ActionListItem>
          );
        })}
      </ActionList>
    </Popover>
  );
};

export default SortComponent;
